/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import {
  ENABLE_DISABLE_ROLE_DIALOG,
  CANCEL_TEXT,
} from '../../Constants/strings.js';
import FormDialogContent from '../../Components/FormDialogContent/formDialogContent.js';

const EnableDisableRoleDialog = ({
  handleCloseAction,
  selectedRole,
  handleEnableDisableAction,
  setIsDialogOpen,
  setRows,
  handleSnackbar,
  setIsEdit,
}) => {
  const content = selectedRole.isActive
    ? ENABLE_DISABLE_ROLE_DIALOG.DISABLE
    : ENABLE_DISABLE_ROLE_DIALOG.ENABLE;

  return (
    <FormDialogContent 
    open={selectedRole !== null} 
    title={content} 
    cancelButtonId={'cancel-' + content.BUTTON_ID} 
    submitButtonId={content.BUTTON_ID}
    button1={CANCEL_TEXT}
    button2={content.BUTTON_TEXT}
    button1Action={() => handleCloseAction(setIsDialogOpen, setIsEdit)}
    button2Action={() =>
      handleEnableDisableAction(
        selectedRole,
        setRows,
        setIsDialogOpen,
        handleSnackbar,
        setIsEdit,
      )
    }
    />
  );
};

EnableDisableRoleDialog.propTypes = {
  handleCloseAction: PropTypes.func.isRequired,
  handleEnableDisableAction: PropTypes.func.isRequired,
  selectedRole: PropTypes.object.isRequired,
  setIsDialogOpen: PropTypes.func.isRequired,
  setRows: PropTypes.func.isRequired,
  handleSnackbar: PropTypes.func.isRequired,
  setIsEdit: PropTypes.func.isRequired,
};

export default EnableDisableRoleDialog;
